module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_03-402f0af1e55bd8e590348566b43ad224.jpg";